import React, { Component } from "react";
import { Row, Col, UncontrolledAlert, Card, Button, CardHeader, CardBody, Alert } from "reactstrap";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput } from "../../Shared/Forms";
import { MdAdd } from "react-icons/md";
import NutrientsCaloriesForm from "./NutrientsCaloriesForm";
//import { MySelect } from "../../Shared/Forms/Select";
import MeasureDropDown from "./MeasureDropDown";
class LibraryForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
            submitBottonClick: false,
            formData: null,
            errorFromNutrients: false,
        };
    }

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    returnDataFromNutrientValue = (data) => {
     
        try {
            if (data) {
                let refineData = [
                    {
                        name: this.state.formData.name,
                        measure: this.state.formData.measure.name,
                        nutrients: [{ key: "calories", value: this.state.formData.calories }],
                    },
                ];

                for (let i = 0; i < data.length; i++) {
                    refineData[0].nutrients.push(data[i]);
                }

                setTimeout(() => {
                    this.setState({ submitBottonClick: false });
                }, 2000);

                //call the submit form from manager here.

                this.props.formSubmit(refineData[0]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    validateNutrients = (error) => {
        this.setState({ errorFromNutrients: error });
    };

    handleSubmit = (data) => {
        this.setState({ submitBottonClick: true, formData: data }, () => {});
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.submitted) {
            this.resetForm();
        }
    }

    resetForm = () => {
        this.refs.foodLibraryForm.reset();
        this.props.resetButton();
    };

    reset = () => {
        this.props.resetButton();
        this.resetForm();
    };

    render() {
        const { canSubmit, submitBottonClick, errorFromNutrients } = this.state;
        const { submitting, error, hasParams, selectedRow, isView, fetchingRow, submitted, fetchingError, resetButton, editmode } = this.props;
        let caloriesValue = null;
        if (selectedRow !== null) {
            selectedRow &&
                selectedRow.nutrients &&
                selectedRow.nutrients.map((e) => {
                    if (e.key === "calories") {
                        caloriesValue = e.value;
                    }
                    return null;
                });
        }
        return (
            <React.Fragment>
                <div>
                    <Row>
                        <Col>
                            <Card>
                                {isView ? <CardHeader>View Food Item</CardHeader> : <CardHeader>{hasParams ? "Edit" : "Create"} Food item</CardHeader>}
                                <CardBody>
                                    {error && !error.errors ? <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert> : null}
                                    {error && error.errors && error.errors.length ? (
                                        <UncontrolledAlert color="danger">
                                            {error.errors.map((error, index) => (
                                                <p key={index}>{error.message}</p>
                                            ))}
                                        </UncontrolledAlert>
                                    ) : null}
                                    {fetchingError ? <UncontrolledAlert color="danger">{fetchingError.message}</UncontrolledAlert> : null}

                                    {fetchingRow && (
                                        <Alert color="info">
                                            <Spinner message="Fetching merchant's details" />
                                        </Alert>
                                    )}
                                    <Formsy ref="foodLibraryForm" onValidSubmit={this.handleSubmit} onValid={this.enableButton} onInvalid={this.disableButton} noValidate>
                                        <TextInput
                                            name="name"
                                            value={selectedRow && hasParams ? selectedRow.name : null}
                                            required
                                            disabled={submitting || isView || fetchingRow}
                                            title="Name"
                                            validations={{
                                                minLength: 3,
                                                maxLength: 50,
                                            }}
                                            validationErrors={{
                                                minLength: "Minimum of 3 characters allowed",
                                                maxLength: "Maximum of 50 characters allowed",
                                            }}
                                        />
                                        <TextInput
                                            name="calories"
                                            required
                                            value={hasParams && selectedRow ? caloriesValue : null}
                                            disabled={submitting || isView || fetchingRow}
                                            title="Total Calories (Kcals)"
                                            validations={{
                                                isNumeric: true,
                                            }}
                                            validationErrors={{
                                                isNumeric: "Whole numbers or decimals numbers only allowed",
                                            }}
                                        />
                                        <MeasureDropDown
                                            isClearable={true}
                                            isMulti={false}
                                            value={
                                                selectedRow && hasParams
                                                    ? {
                                                          id: selectedRow.measure,
                                                          name: selectedRow.measure,
                                                      }
                                                    : null
                                            }
                                            selectedMetrics
                                            valueKey="id"
                                            disabled={submitting || isView || fetchingRow}
                                            innerRef={(c) => {
                                                this.unit = c;
                                            }}
                                            isRequired={true}
                                            name="measure"
                                            title="Metric Unit
                    "
                                        />
                                        {/* <MySelect
                                            name="unit"
                                            value={selectMeasurementObject && selectMeasurementObject[0]}
                                            title="Measurement unit"
                                            options={measurements ? measurements : []}
                                            valueKey="id"
                                            disabled={submitting}
                                            labelKey="name"
                                            innerRef={(c) => {
                                                this.unit = c;
                                            }}
                                            isClearable={true}
                                            required
                                        /> */}
                                        <NutrientsCaloriesForm
                                            submitted={submitted}
                                            valueKey="id"
                                            disabled={hasParams && isView ? true : false}
                                            innerRef={(c) => {
                                                this.caloriesForm = c;
                                            }}
                                            isRequired={false}
                                            name="caloriesId"
                                            title="Select Nutrients
                    "
                                            returnDataFromNutrientValue={this.returnDataFromNutrientValue}
                                            submitBottonClick={submitBottonClick}
                                            hasParams={hasParams}
                                            selectedRow={selectedRow}
                                            isView={isView}
                                            resetButton={resetButton}
                                            validateNutrients={this.validateNutrients}
                                            editmode={editmode}
                                        />
                                        {!isView ? (
                                            <Button type="submit" color="primary" disabled={!canSubmit || submitting || isView || errorFromNutrients} className="pp3 mr-1">
                                                {submitting ? (
                                                    <Spinner size="sm" />
                                                ) : (
                                                    <span>
                                                        {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                                                    </span>
                                                )}
                                            </Button>
                                        ) : null}
                                        {hasParams ? (
                                            <Button type="button" outline color="primary" onClick={() => this.reset()} className="mr-1">
                                                Reset
                                            </Button>
                                        ) : null}
                                    </Formsy>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        );
    }
}

export default LibraryForm;
